import { render, staticRenderFns } from "./SchoolHQSelectItem.vue?vue&type=template&id=17040c4a&"
import script from "./SchoolHQSelectItem.vue?vue&type=script&lang=js&"
export * from "./SchoolHQSelectItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports